import Vue from 'vue'
import Router from 'vue-router'
// import Hasher from '@/pages/HasherPage'
import Hashers from '@/pages/Hashers'
import TrailHistory from '@/pages/TrailHistory'
import LocalKennels from '@/pages/LocalKennels'
// import NextTrail from '@/pages/NextTrail'
import About from '@/pages/About'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/runners',
      name: 'Hashers',
      component: Hashers
    },
    // {
    //   path: '/hasher/:id',
    //   name: 'HasherPage',
    //   component: Hasher
    // },
    // {
    //   path: '/trail/next',
    //   name: 'NextTrail',
    //   component: NextTrail
    // },
    {
      path: '/trailhistory/:selectedTrailId?',
      props:  (route) => ({ view: route.query.view,
                            selectedTrailId: route.params.selectedTrailId}),
      name: 'TrailHistory',
      component: TrailHistory
    },
    {
      path: '/localkennels',
      name: 'LocalKennels',
      component: LocalKennels
    },
    { path: '/',
      name: 'About',
      component: About
    }
  ]
})
